var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "" } },
        [
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div1" }, [_vm._v("采购管理")]),
          ]),
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div2" }, [_vm._v("异常入库列表")]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eltabs", staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.tabName,
                callback: function ($$v) {
                  _vm.tabName = $$v
                },
                expression: "tabName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "拒收中", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "被退货中", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "退货中", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "已完成", name: "3" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClick1 },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "微商", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "客服", name: "2" } }),
              _c("el-tab-pane", { attrs: { label: "品牌", name: "3" } }),
              _c("el-tab-pane", { attrs: { label: "内部出库", name: "4" } }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "query" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    margin: "10px",
                    "font-size": "14px",
                    color: "#2d7edf",
                  },
                },
                [_vm._v(" 数据查询 ")]
              ),
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: { model: _vm.queryForm, "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItem",
                      attrs: { label: "订单编号", prop: "orderId" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单编号" },
                        model: {
                          value: _vm.queryForm.orderId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "orderId", $$v)
                          },
                          expression: "queryForm.orderId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItem",
                      attrs: { label: "退货物流", prop: "logisticsId" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入包裹单号" },
                        model: {
                          value: _vm.queryForm.logisticsId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "logisticsId", $$v)
                          },
                          expression: "queryForm.logisticsId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "formItem",
                      attrs: { label: "日期", prop: "date" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          size: "mini",
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy- MM- dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.queryForm.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "date", $$v)
                          },
                          expression: "queryForm.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("queryForm")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableData", staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "highlight-current-row": "",
                data: _vm.tableData.list,
                "header-cell-style": { textAlign: "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "border" }, [
                          _c(
                            "div",
                            { staticStyle: { color: "#4168e7" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: props.row.orderCommodityList,
                                    "header-cell-style": {
                                      textAlign: "center",
                                      color: "#333",
                                    },
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品信息",
                                      "min-width": "500px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "flex-start",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  _c("el-image", {
                                                    staticStyle: {
                                                      width: "100px",
                                                      height: "100px",
                                                      "margin-right": "50px",
                                                    },
                                                    attrs: {
                                                      src: _vm.img(
                                                        scope.row.image
                                                      ),
                                                      fit: "cover",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.brandName
                                                      ) +
                                                        " " +
                                                        _vm._s(scope.row.name) +
                                                        " ￥" +
                                                        _vm._s(
                                                          scope.row.price
                                                        ) +
                                                        "/盒"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100px",
                                      label: "正常收货",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (c) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(c.row.normalNumber) +
                                                  "件 "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100px",
                                      label: "破损收货",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (c) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(c.row.damagedNumber) +
                                                  "件 "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: props.row.orderComplimentaryList,
                                    "header-cell-style": {
                                      textAlign: "center",
                                      color: "#333",
                                    },
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "赠品信息",
                                      "min-width": "500px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "flex-start",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  _c("el-image", {
                                                    staticStyle: {
                                                      width: "100px",
                                                      height: "100px",
                                                      "margin-right": "50px",
                                                    },
                                                    attrs: {
                                                      src: _vm.img(
                                                        scope.row.image
                                                      ),
                                                      fit: "cover",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.brandName
                                                      ) +
                                                        " " +
                                                        _vm._s(scope.row.name) +
                                                        " ￥" +
                                                        _vm._s(
                                                          scope.row.price
                                                        ) +
                                                        "/盒"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100px",
                                      label: "正常收货",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (c) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(c.row.normalNumber) +
                                                  "件 "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100px",
                                      label: "破损收货",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (c) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(c.row.damagedNumber) +
                                                  "件 "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单编号",
                  prop: "orderId",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "包裹单号", prop: "parcelNumber" },
              }),
              _c("el-table-column", {
                attrs: { label: "申请时间", prop: "applyTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "客服", prop: "service" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "fontSty",
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row.id, {
                                  exType: scope.row.exType,
                                  orderType: scope.row.orderType,
                                })
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm.tabName != 3
                          ? _c(
                              "span",
                              {
                                staticClass: "fontSty",
                                staticStyle: { "margin-left": "20px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addStorage(scope.row)
                                  },
                                },
                              },
                              [_vm._v("入库")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("span", { staticClass: "demonstration" }, [
              _vm._v("共" + _vm._s(_vm.tableData.totalPage) + "页"),
            ]),
            _c("span", { staticClass: "demonstration" }, [
              _vm._v("共" + _vm._s(_vm.tableData.totalNum) + "条"),
            ]),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage1,
                "page-sizes": [10, 20, 50, 100],
                total: _vm.tableData.totalNum,
                "prev-text": "上一页",
                "next-text": "下一页",
                layout: "sizes,prev,pager,next,jumper",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
                "update:currentPage": function ($event) {
                  _vm.currentPage1 = $event
                },
                "update:current-page": function ($event) {
                  _vm.currentPage1 = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticStyle: { height: "50px" } }),
      _c(
        "el-dialog",
        {
          attrs: {
            "modal-append-to-body": "",
            "append-to-body": "",
            title: "提交填写入库",
            visible: _vm.dialogVisible,
            width: "800px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "diaContext" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeNum,
                    callback: function ($$v) {
                      _vm.activeNum = $$v
                    },
                    expression: "activeNum",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "商品", name: "0" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "main",
                        staticStyle: { overflow: "auto", height: "500px" },
                      },
                      _vm._l(
                        _vm.selectData.orderCommodityList,
                        function (item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "context" },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(item.brandName + " " + item.name) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "normalNumber" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "font-size": "16px",
                                        "font-weight": "500",
                                      },
                                    },
                                    [_vm._v("正常商品入库")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "14px" } },
                                    [
                                      _vm._v(
                                        " 可入库数" +
                                          _vm._s(item.normalNumber) +
                                          "件"
                                      ),
                                    ]
                                  ),
                                ]),
                                item.normalNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "addStorge",
                                        staticStyle: {
                                          "border-bottom": "1px solid #eee",
                                          "padding-left": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(" 请选择仓库"),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-bottom": "20px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "collapse-tags": "",
                                              "value-key": "id",
                                              clearable: "",
                                              multiple: "",
                                              placeholder: "请选择仓库",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectClick1(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.normalWarehouses,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "normalWarehouses",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.normalWarehouses",
                                            },
                                          },
                                          _vm._l(
                                            JSON.parse(JSON.stringify(_vm.op)),
                                            function (items) {
                                              return _c("el-option", {
                                                key: items.id,
                                                attrs: {
                                                  value: items,
                                                  label: items.name,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "wareHouse" },
                                          _vm._l(
                                            item.normalWarehouses,
                                            function (items, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _c(
                                                    "el-form",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: items.name,
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入商品库存",
                                                            },
                                                            model: {
                                                              value:
                                                                items.quantityStock,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "quantityStock",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.quantityStock",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "经手人",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入经手人",
                                                            },
                                                            model: {
                                                              value:
                                                                items.handledBy,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "handledBy",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.handledBy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "damagedNumber" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "font-size": "16px",
                                        "font-weight": "500",
                                      },
                                    },
                                    [_vm._v("破损商品入库")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "14px" } },
                                    [
                                      _vm._v(
                                        " 可入库数" +
                                          _vm._s(item.damagedNumber) +
                                          "件"
                                      ),
                                    ]
                                  ),
                                ]),
                                item.damagedNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "addStorge",
                                        staticStyle: {
                                          "border-bottom": "1px solid #eee",
                                          "padding-left": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(" 请选择仓库"),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-bottom": "20px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "collapse-tags": "",
                                              "value-key": "id",
                                              clearable: "",
                                              multiple: "",
                                              placeholder: "请选择仓库",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectClick2(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.damagedWarehouses,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "damagedWarehouses",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.damagedWarehouses",
                                            },
                                          },
                                          _vm._l(
                                            JSON.parse(JSON.stringify(_vm.op)),
                                            function (items) {
                                              return _c("el-option", {
                                                key: items.id,
                                                attrs: {
                                                  value: items,
                                                  label: items.damagedName,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "wareHouse" },
                                          _vm._l(
                                            item.damagedWarehouses,
                                            function (items, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _c(
                                                    "el-form",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              items.damagedName,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              attrs: {
                                                                min: 0,
                                                                controls: false,
                                                                placeholder:
                                                                  "请输入商品库存",
                                                              },
                                                              model: {
                                                                value:
                                                                  items.quantityStock,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      items,
                                                                      "quantityStock",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "items.quantityStock",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "经手人",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入经手人",
                                                            },
                                                            model: {
                                                              value:
                                                                items.handledBy,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "handledBy",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.handledBy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _c("el-tab-pane", { attrs: { label: "赠品", name: "1" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "main",
                        staticStyle: { overflow: "auto", height: "500px" },
                      },
                      _vm._l(
                        _vm.selectData.orderComplimentaryList,
                        function (item) {
                          return _c(
                            "div",
                            { key: item.name, staticClass: "context" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "title",
                                  staticStyle: { "font-weight": "700" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.brandName + " " + item.name) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "normalNumber" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "font-size": "16px",
                                        "font-weight": "500",
                                      },
                                    },
                                    [_vm._v("正常商品入库")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "16px" } },
                                    [
                                      _vm._v(
                                        " 可入库数" +
                                          _vm._s(item.normalNumber) +
                                          "件"
                                      ),
                                    ]
                                  ),
                                ]),
                                item.normalNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "addStorge",
                                        staticStyle: {
                                          "border-bottom": "1px solid #eee",
                                          "padding-left": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(" 请选择仓库"),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-bottom": "20px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "collapse-tags": "",
                                              "value-key": "id",
                                              clearable: "",
                                              multiple: "",
                                              placeholder: "请选择仓库",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectClick1(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.normalWarehouses,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "normalWarehouses",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.normalWarehouses",
                                            },
                                          },
                                          _vm._l(
                                            JSON.parse(JSON.stringify(_vm.op)),
                                            function (items) {
                                              return _c("el-option", {
                                                key: items.id,
                                                attrs: {
                                                  value: items,
                                                  label: items.name,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "wareHouse" },
                                          _vm._l(
                                            item.normalWarehouses,
                                            function (items, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _c(
                                                    "el-form",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: items.name,
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入商品库存",
                                                            },
                                                            model: {
                                                              value:
                                                                items.quantityStock,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "quantityStock",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.quantityStock",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "经手人",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入经手人",
                                                            },
                                                            model: {
                                                              value:
                                                                items.handledBy,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "handledBy",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.handledBy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "damagedNumber" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#4168e7",
                                        "font-size": "16px",
                                        "font-weight": "500",
                                      },
                                    },
                                    [_vm._v("破损商品入库")]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "14px" } },
                                    [
                                      _vm._v(
                                        " 可入库数" +
                                          _vm._s(item.damagedNumber) +
                                          "件"
                                      ),
                                    ]
                                  ),
                                ]),
                                item.damagedNumber
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "addStorge",
                                        staticStyle: {
                                          "border-bottom": "1px solid #eee",
                                          "padding-left": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(" 请选择仓库"),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              "margin-bottom": "20px",
                                              "margin-top": "10px",
                                            },
                                            attrs: {
                                              "collapse-tags": "",
                                              "value-key": "id",
                                              clearable: "",
                                              multiple: "",
                                              placeholder: "请选择仓库",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectClick2(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.damagedWarehouses,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "damagedWarehouses",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.damagedWarehouses",
                                            },
                                          },
                                          _vm._l(
                                            JSON.parse(JSON.stringify(_vm.op)),
                                            function (items) {
                                              return _c("el-option", {
                                                key: items.id,
                                                attrs: {
                                                  value: items,
                                                  label: items.damagedName,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "wareHouse" },
                                          _vm._l(
                                            item.damagedWarehouses,
                                            function (items, index) {
                                              return _c(
                                                "span",
                                                { key: index },
                                                [
                                                  _c(
                                                    "el-form",
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label:
                                                              items.damagedName,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              attrs: {
                                                                min: 0,
                                                                controls: false,
                                                                placeholder:
                                                                  "请输入商品库存",
                                                              },
                                                              model: {
                                                                value:
                                                                  items.quantityStock,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      items,
                                                                      "quantityStock",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "items.quantityStock",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "经手人",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入经手人",
                                                            },
                                                            model: {
                                                              value:
                                                                items.handledBy,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    items,
                                                                    "handledBy",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "items.handledBy",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitClick } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }